import { styled } from '@gluestack-style/react';
import { Pressable } from 'react-native';
export default styled(Pressable, {
    _web: {
        ':focusVisible': {
            outlineWidth: '2px',
            outlineColor: '$primary700',
            outlineStyle: 'solid',
            _dark: {
                outlineColor: '$primary300',
            },
        },
    },
}, {
    componentName: 'Pressable',
});
